export default __webpack_public_path__ + "static/media/eye.e06ddff9.svg";